import { useTieneRol } from "@/lib/sesion";

/**
 * True si la identidad EFECTIVA de la sesión tiene el rol ADMIN_SICEN. Se usa
 * para mostrar herramientas de soporte/diagnóstico (IDs internos, JSON crudo)
 * que confunden a los usuarios finales no técnicos.
 *
 * Durante una suplantación devuelve el rol del usuario suplantado, que es lo
 * que debe verse: el administrador está validando cómo experimenta el sistema
 * esa persona. Para saber si quien está detrás puede ABRIR una suplantación,
 * usar `useEsAdminReal`.
 */
export function useEsAdmin(): boolean {
  return useTieneRol("ADMIN_SICEN");
}
